import React, { useEffect } from 'react';
import { Hero } from '../components/landing/Hero';
import { ProblemSection } from '../components/landing/ProblemSection';
import { SolutionSection } from '../components/landing/SolutionSection';
import { WhatIncluded } from '../components/landing/WhatIncluded';
import { ForWhoSection } from '../components/landing/ForWhoSection';
import { PricingSection } from '../components/landing/PricingSection';
import { Footer } from '../components/landing/Footer';
import { SaleNotification } from '../components/landing/SaleNotification';
import { initMetaPixel } from '../hooks/useMetaPixel';
export function LandingPage() {
  useEffect(() => {
    // Initialize Meta Pixel and track PageView on mount
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-cream font-sans selection:bg-purple selection:text-white" data-id="element-192">
      <Hero data-id="element-193" />
      <ProblemSection data-id="element-194" />
      <SolutionSection data-id="element-195" />
      <WhatIncluded data-id="element-196" />
      <ForWhoSection data-id="element-197" />
      <PricingSection data-id="element-198" />
      <Footer data-id="element-199" />
      <SaleNotification data-id="element-200" />
    </div>;
}